import { fetchSinToken } from '../helpers/fetch';

export const startRegister = async (data = {}, endpoint) => {
  const result = await fetchSinToken(endpoint, data, 'POST');
  const body = await result.json();
  console.log(result.status, body);
  return { code: result.status, ...body };
};
